// 是否是移动端
export const isMobile = () => {
  const userAgent = navigator.userAgent;

  return (
    /Android|webOS|iPhone|iPod|BlackBerry/i.test(userAgent) ||
    /iPad|mobile/i.test(userAgent)
  );
};
